import { Redirect } from "react-router-dom";

const Admin = () => {
  return <Redirect to="/admin/csv" />;
};

export default Admin;
